import { useEffect, useState } from "react";

import debounce from "lodash/debounce";

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        windowWidth : window.innerWidth,
        windowHeight: window.innerHeight
    });

    const handleWindowSize = debounce(() => {
        setWindowSize({
            windowWidth : window.innerWidth,
            windowHeight: window.innerHeight
        });
    }, 50);

    useEffect(() => {
        window.addEventListener("resize", handleWindowSize);
        return () => {
            window.removeEventListener("resize", handleWindowSize);
        };
    }, []);

    const isMobileView = windowSize.windowWidth <= 800;

    return {
        windowWidth : windowSize.windowWidth,
        isMobileView,
        windowHeight: windowSize.windowHeight
    };
};

export default useWindowSize;
